import _JSXStyle from "styled-jsx/style";
import PropTypes from 'prop-types';
import React from 'react';
export const TagText = _ref => {
  let {
    children,
    dataTest
  } = _ref;
  return /*#__PURE__*/React.createElement("span", {
    "data-test": dataTest,
    className: "jsx-1110058759"
  }, children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1110058759"
  }, [".jsx-1110058759{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}"]));
};
TagText.propTypes = {
  dataTest: PropTypes.string.isRequired,
  children: PropTypes.node
};